import { AxiosResponse } from "axios";
import API from "../api";
import { MemberAvailability  } from "../models/members/member.availability";

import BaseService from "./_base.service";

const endpoint = "availabilities";

interface CreateAvailability extends Omit<MemberAvailability, "members"> {
  memberId?: number;
  equipmentId?: number;
}

const AvailabilityService = {
  ...BaseService<MemberAvailability>({ endpoint }),
  async cancelAvailabilty(availabilityId: number): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/cancel/${availabilityId}`);
  },
  async create(data: CreateAvailability) {
    return await API.post(`${endpoint}`, data);
  },
};

export default AvailabilityService;
